import CurrencyCellHtml         from '../../../app-lite/grids/templates/cell.currency.html';
import EditableCellHtml         from '../../../app-lite/grids/templates/cell.editable.html';
import EditableCurrencyCellHtml from '../../../app-lite/grids/templates/cell.currency.editable.html';
import PaymentMethodCellHtml    from '../../customers/templates/customer-cash-payment.payment-method.cell.html';
import RemoveRowCellHtml        from '../../../app-lite/grids/templates/cell.remove-row.html';

export function CashDepositCtrl (
  $q,
  $rootScope,
  $scope,
  $timeout,
  $translate,
  $uibModalInstance,
  blockUI,
  customer,
  dateParsing,
  deposit,
  integrations,
  invoice,
  isRefund,
  messages,
  methods,
  tillpaymentsApi,
  terminalId,
  workshopAPI
) {

  $scope.balance        = '0';
  $scope.block          = blockUI.instances.get('cashDepositBlock');
  $scope.customer       = customer;
  $scope.integrations   = integrations;
  $scope.invoice        = invoice;
  $scope.isRefund       = isRefund;
  $scope.isEftPosUsed   = false;
  $scope.payment        = {};
  $scope.paymentMethods = methods;
  $scope.terminals      = [];
  $scope.refundAmount   = deposit ? deposit.amount : null;

  $scope.terminal = {
    terminalId
  };

  $scope.grid = {
    columnDefs: [
      {
        cellTemplate  : RemoveRowCellHtml,
        enableCellEdit: false,
        width         : '43px'
      },
      {
        cellFilter          : 'customerPaymentMethod:paymentMethods',
        displayName         : $translate.instant('GENERAL_SPACE.FIELD.PAYMENT_METHOD'),
        editableCellTemplate: PaymentMethodCellHtml,
        field               : 'customer_payment_method',
        handleChange        : ( row ) => {
          const method = $scope.paymentMethods.filter(( paymentMethod = {} ) => paymentMethod.id === row.entity.customer_payment_method)[0];

          $scope.isEftPosUsed = method.use_eftpos;

          row.entity.payment_type = method.payment_method;
          row.entity.use_eftpos   = method.use_eftpos;

          if ($scope.isEftPosUsed && $rootScope.Company.hasIntegration('tillpayments-pos')) {
            $scope.block.start();

            tillpaymentsApi.getTerminals()
            .then(terminals => {
              $scope.terminals = terminals;

              if ($scope.terminal.terminalId) {
                $scope.setDefaultTerminal();
              }
            })
            .catch(err => {
              messages.error(err);
            })
            .finally(() => {
              $scope.block.stop();
            });
          }
        }
      },
      {
        displayName         : $translate.instant('GENERAL_SPACE.FIELD.REFERENCE'),
        editableCellTemplate: EditableCellHtml,
        field               : 'reference'
      },
      {
        cellClass           : 'align-right',
        cellFilter          : 'globalCurrency',
        cellTemplate        : CurrencyCellHtml,
        displayName         : $translate.instant('JS_SPACE.COLUMNS.AMOUNT'),
        editableCellTemplate: EditableCurrencyCellHtml,
        field               : 'amount',
        width               : '101px',
        enableCellEdit      : !isRefund
      }
    ],
    data                   : 'payment.deposit_payment_methods',
    enableCellEditOnFocus  : true,
    enableCellSelection    : true,
    enableMultiSelect      : false,
    enableRowSelection     : false,
    rowHeight              : 43,
    virtualizationThreshold: 9999
  };

  $scope.addItem = function () {
    $scope.payment.deposit_payment_methods.push({
      amount                 : '0.00',
      customer_payment_method: null,
      payment_type           : '',
      reference              : '',
      use_eftpos             : false
    });
  };

  $scope.getTotals = function () {
    var totals = {
      balance: new BigDecimal($scope.invoice.balance_due.toString()),
      total  : BigDecimal.ZERO
    };

    angular.forEach($scope.payment.deposit_payment_methods, method => {
      const amount = new BigDecimal(method.amount.toString());

      totals.total = totals.total.add(amount);
    });

    return totals;
  };

  $scope.handleTerminalSelection = function () {
    $scope.block.start();

    $scope.terminal = $scope.terminals.filter(terminal => terminal.terminalId === $scope.terminal.terminalId)[0];

    tillpaymentsApi.saveDefaultUserTerminal($scope.terminal)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.TILLPAYMENTS.USER_PREFERENCE_UPDATED'), 'success');

      $scope.setDefaultTerminal();
    })
    .catch(err => {
      messages.error($translate.instant('USER_PREFERENCE_NOT_UPDATED'));

      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.prepPayment = function () {
    if ($scope.isRefund && deposit) {
      const matchedMethod = $scope.paymentMethods.filter(m => m.payment_method === deposit.payment_type)[0] || {};

      $scope.payment.deposit_payment_methods = [{
        amount                 : new BigDecimal(deposit.amount.toString()).toString(),
        customer_payment_method: matchedMethod.id || $scope.paymentMethods[0].id,
        payment_type           : deposit.payment_type,
        reference              : deposit.reference || '',
        use_eftpos             : !!matchedMethod.use_eftpos
      }];

      $scope.balance = BigDecimal.ZERO.toString();
    }
    else {
      $scope.payment.deposit_payment_methods = [{
        amount                 : '0.00',
        customer_payment_method: $scope.paymentMethods[0].id,
        payment_type           : $scope.paymentMethods[0].payment_method,
        reference              : '',
        use_eftpos             : $scope.paymentMethods[0].use_eftpos
      }];
    }
  };

  $scope.removeItem = function (row) {
    $scope.payment.deposit_payment_methods.splice(row.rowIndex, 1);

    $scope.updateTotals();
  };

  $scope.setDefaultTerminal = function () {
    $scope.terminal = $scope.terminals.filter(terminal =>
      terminal.terminalId === $scope.terminal.terminalId
    )[0] || {};
  };

  $scope.takeDeposit = function () {
    $scope.block.start();

    let resolvedInvoiceId = $scope.invoice && $scope.invoice.id;

    return $scope.validate()
    .then(() => {
      const methodData    = $scope.payment.deposit_payment_methods;
      const primaryMethod = methodData[0];
      const isTerminal    = primaryMethod.use_eftpos && $rootScope.Company.hasIntegration('tillpayments-pos');

      var totalAmount = BigDecimal.ZERO;

      angular.forEach(methodData, method => {
        totalAmount = totalAmount.add(new BigDecimal(method.amount.toString()));
      });

      /**
       * WS-6301: submit the user-selected payment method verbatim (Cash, Credit Card,
       * whatever the company has configured as their EFTPOS-active method, etc.) and
       * pass terminal-involvement as a separate flag. Previously this overrode
       * payment_type to the literal string 'tillpayments_terminal' for any deposit
       * processed via the WorkshopPay terminal hardware, which discarded the user's
       * actual selection and broke the Payment Reconciliation report's grouping.
       * The BE (WS-6300) consumes via_terminal for pending-status detection.
       **/
      const depositData = {
        customer_id  : $scope.invoice.customer_id,
        invoice_id   : $scope.invoice.id,
        date_received: dateParsing.today(),
        payment_type : primaryMethod.payment_type,
        via_terminal : isTerminal,
        reference    : primaryMethod.reference,
        amount       : totalAmount.toString(),
        status       : 'O'
      };

      if (!isTerminal) {
        $uibModalInstance.close({ deposit: depositData });
        return $q.when();
      }

      // Check terminal connectivity before creating the pending deposit
      return tillpaymentsApi.checkTerminalConnectivity($scope.terminal)
      .then(freshTerminal => {
        /**
         * WS-6303: reuse any in-flight pending terminal deposit from a prior
         * failed attempt instead of pushing a duplicate. The previous attempt's
         * pending row stays on the invoice when the terminal returns failure /
         * timeout / decline / Unknown. Without this guard every retry creates a
         * fresh pending row, causing duplicate customer_deposits and (when the
         * BE patch receives line items without ids on the retry) duplicate
         * invoice_items as well. Match purely on the in-flight criteria
         * (pending + via_terminal + not destroyed) so the user changing the
         * amount between attempts supersedes the prior row rather than
         * orphaning it — the new amount is written onto the existing row so
         * the next patch / terminal-success callback sees the correct value.
         * Note: BE returns _destroy as the string "0" for kept rows; FE sets
         * it to "1" on delete, so the predicate excludes "1" explicitly.
         **/
        const matchingPending = ($scope.invoice.customer_deposits_attributes || []).find(d =>
          d._destroy !== '1'
          && d.payment_status === 'pending'
          && d.via_terminal === true
        );

        if (matchingPending) {
          /**
           * If the user changed the amount between attempts we must patch the
           * BE row before the terminal call. Otherwise the terminal charges
           * the new amount but on success the BE's tillpayments_invoke_sync
           * chain reads the stale deposit.amount when building the
           * customer_payment + dispersal that gets pushed to Xero/QBO/MYOB,
           * resulting in an under/over-recorded payment in accounting. Same-
           * amount retries skip the patch round-trip and go straight to the
           * terminal call.
           **/
          const amountChanged = parseFloat(matchingPending.amount) !== parseFloat(totalAmount.toString());

          matchingPending.amount = totalAmount.toString();
          matchingPending.tillpayments_terminal_payment_intent_id = null;

          if (!amountChanged) {
            return tillpaymentsApi.processDepositTransaction(
              matchingPending,
              totalAmount.toString(),
              freshTerminal,
              $scope.invoice
            );
          }

          return workshopAPI.patch('invoice', $scope.invoice, 'invoice')
          .then(invoice => {
            $scope.invoice.customer_deposits_attributes = invoice.customer_deposits_attributes;
            $scope.invoice.balance_due                  = invoice.balance_due;
            $scope.invoice.invoice_items_attributes     = invoice.invoice_items_attributes;

            const refreshed = (invoice.customer_deposits_attributes || []).find(d =>
              d._destroy !== '1'
              && d.payment_status === 'pending'
              && d.via_terminal === true
            );

            return tillpaymentsApi.processDepositTransaction(
              refreshed || matchingPending,
              totalAmount.toString(),
              freshTerminal,
              $scope.invoice
            );
          });
        }

        depositData.payment_status = 'pending';

        $scope.invoice.customer_deposits_attributes.push(depositData);

        return workshopAPI.patch('invoice', $scope.invoice, 'invoice')
        .then(invoice => {
          /**
           * Capture the id from the patch response. When a user takes a terminal
           * deposit on a brand-new (unsaved) invoice, $scope.invoice.id is null going
           * into the patch — the BE inserts and assigns an id. We hold it in a closure
           * so the post-terminal GET below uses the saved id rather than reading from
           * $scope.invoice (which may not have been updated, mutated, or even survived
           * the terminal modal's lifecycle).
           **/
          resolvedInvoiceId = invoice.id || $scope.invoice.id;

          $scope.invoice.id                           = resolvedInvoiceId;
          $scope.invoice.customer_deposits_attributes = invoice.customer_deposits_attributes;
          $scope.invoice.balance_due                  = invoice.balance_due;
          /**
           * WS-6303: sync invoice_items_attributes from the response so the BE-
           * assigned ids for any newly-inserted line items propagate back into
           * scope. Without this, if the user retries on a brand-new invoice (where
           * the line items went in id-less on the first patch and the terminal
           * failed before the response could finalise), the next patch sends the
           * same items id-less again and the BE inserts duplicates.
           **/
          $scope.invoice.invoice_items_attributes     = invoice.invoice_items_attributes;

          const pendingDeposit = invoice.customer_deposits_attributes.find(
            d => d.payment_status === 'pending' && !d.tillpayments_terminal_payment_intent_id
          );

          if (!pendingDeposit) {
            return $q.reject('Failed to create pending deposit');
          }

          return tillpaymentsApi.processDepositTransaction(
            pendingDeposit,
            totalAmount.toString(),
            freshTerminal,
            $scope.invoice
          );
        });
      })
      .then(() => workshopAPI.get('/invoice', resolvedInvoiceId))
      .then(updatedInvoice => {
        $scope.invoice.customer_deposits_attributes    = updatedInvoice.customer_deposits_attributes;
        $scope.invoice.balance_due                     = updatedInvoice.balance_due;
        $scope.invoice.total                           = updatedInvoice.total;
        $scope.invoice.tillpayments_surcharge_amount   = updatedInvoice.tillpayments_surcharge_amount;
        $scope.invoice.tillpayments_surcharge_subtotal = updatedInvoice.tillpayments_surcharge_subtotal;
        $scope.invoice.tillpayments_surcharge_tax      = updatedInvoice.tillpayments_surcharge_tax;

        $uibModalInstance.close({ terminal: true });
      });
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.processTerminalDeposit = function (deposit, amount) {
    return tillpaymentsApi.processDepositTransaction(
      deposit,
      amount,
      $scope.terminal,
      $scope.invoice
    );
  };

  /**
   * WS-6303: dismissing the modal after a failed / timed-out terminal deposit
   * used to leave the pending customer_deposit row alive in the BE — the user
   * would see the orphan persist on refresh because $uibModalInstance.dismiss()
   * alone makes no BE call. Mark any in-flight pending terminal row for
   * destroy and patch the invoice before closing so the cancel intent
   * actually reaches the database. Refund flow skips this because its
   * pending-state semantics are different (handled by parent Deposit.refund).
   **/
  $scope.cancel = function () {
    if ($scope.isRefund) {
      $uibModalInstance.dismiss();
      return;
    }

    const inflight = ($scope.invoice.customer_deposits_attributes || []).find(d =>
      d._destroy !== '1'
      && d.payment_status === 'pending'
      && d.via_terminal === true
    );

    if (!inflight) {
      $uibModalInstance.dismiss();
      return;
    }

    inflight._destroy = '1';
    $scope.block.start();

    return workshopAPI.patch('invoice', $scope.invoice, 'invoice')
    .then(invoice => {
      $scope.invoice.customer_deposits_attributes = invoice.customer_deposits_attributes;
      $scope.invoice.balance_due                  = invoice.balance_due;
      $scope.invoice.invoice_items_attributes     = invoice.invoice_items_attributes;
      $uibModalInstance.dismiss();
    })
    .catch(err => {
      inflight._destroy = '0';
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.refundDeposit = function () {
    $scope.block.start();

    const selectedMethod = $scope.payment.deposit_payment_methods[0];
    const isTerminal = selectedMethod && selectedMethod.use_eftpos && $rootScope.Company.hasIntegration('tillpayments-pos');

    return $q.when()
    .then(() => {
      /**
       * Re-check terminal connectivity per click — the dropdown list is fetched
       * once on modal open and goes stale. Without this, a terminal that came
       * online after the modal opened still reports "not active" until the user
       * closes and reopens the modal. takeDeposit already does this; mirror it
       * here so refundDeposit behaves consistently.
       **/
      if (!isTerminal) {
        return $q.when();
      }
      return tillpaymentsApi.checkTerminalConnectivity($scope.terminal);
    })
    .then(freshTerminal => {
      if (!isTerminal) {
        return $q.when();
      }

      return tillpaymentsApi.processDepositRefundTransaction(
        deposit,
        deposit.amount,
        freshTerminal || $scope.terminal,
        $scope.invoice
      );
    })
    .then(() => {
      /**
       * Only refresh from BE for the terminal flow — that path has already
       * committed the refund + surcharge reversal server-side, so the scope
       * needs to catch up to BE state. The non-terminal path does NOT touch
       * the BE here; instead the parent Deposit.prototype.refund handler
       * sets deposit._destroy and PATCHes the invoice. Replacing
       * customer_deposits_attributes here would orphan the captured deposit
       * reference and the parent's _destroy mutation would never make it
       * into the patch payload, leaving the deposit alive on save.
       **/
      if (!isTerminal) {
        $uibModalInstance.close({ refunded: true, terminal: isTerminal });
        return;
      }
      return workshopAPI.get('/invoice', $scope.invoice.id)
      .then(updatedInvoice => {
        $scope.invoice.customer_deposits_attributes    = updatedInvoice.customer_deposits_attributes;
        $scope.invoice.balance_due                     = updatedInvoice.balance_due;
        $scope.invoice.total                           = updatedInvoice.total;
        $scope.invoice.tillpayments_surcharge_amount   = updatedInvoice.tillpayments_surcharge_amount;
        $scope.invoice.tillpayments_surcharge_subtotal = updatedInvoice.tillpayments_surcharge_subtotal;
        $scope.invoice.tillpayments_surcharge_tax      = updatedInvoice.tillpayments_surcharge_tax;

        $uibModalInstance.close({ refunded: true, terminal: isTerminal });
      });
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.updateTotals = function () {
    if ($scope.isRefund) {
      return;
    }

    const totals = $scope.getTotals();

    $scope.excessBalance = false;

    if (totals.total.isGreaterThan(totals.balance)) {
      $scope.balance       = totals.balance.subtract(totals.total).toString();
      $scope.excessBalance = true;
    }
    else {
      $scope.balance = totals.balance.subtract(totals.total).toString();
    }
  };

  $scope.validate = function () {
    const totals = $scope.getTotals();

    if (totals.total.isZero()) {
      return $q.reject($translate.instant('JS_SPACE.MESSAGES.PAYMENT_IS_INSUFFICIENT'));
    }

    if (totals.total.isGreaterThan(totals.balance)) {
      return $q.reject($translate.instant('JS_SPACE.MESSAGES.PAYMENT_EXCEEDS_BALANCE'));
    }

    return $q.when(true);
  };

  $scope.$watch('payment.deposit_payment_methods', items => {
    if (!angular.isArray(items)) {
      return;
    }

    if (!items.length) {
      $scope.addItem();
    }
    else {
      $scope.updateTotals();
    }
  }, true);

  $scope.prepPayment();
}
